import { Box, Typography, Button } from "@mui/material";
import PropTypes from "prop-types";
import SuccessIcon from "../../assets/successPopup.svg";

export default function SuccessPopup({ open, onClose, recipientType }) {
  if (!open) return null;

  const type = recipientType?.toLowerCase() || "provider";
  const destination =
    type === "provider" ? "provider outreach" : "pharmacy outreach";

  const title = "Task Created Successfully";
  const message = `The task has been added to the ${destination} queue. Please navigate to the queue to review the details.`;

  return (
    <Box
      component="div"
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 2000,
        border: "none",
        background: "none",
        padding: 0,
        margin: 0,
      }}
    >
      <Box
        component="button"
        onClick={onClose}
        aria-label="Close success dialog"
        onKeyDown={(e) => {
          if (e.key === "Escape") {
            e.preventDefault();
            onClose?.();
          }
        }}
        sx={{
          position: "absolute",
          inset: 0,
          backgroundColor: "rgba(0,0,0,0.25)",
          backdropFilter: "blur(1px)",
          border: "none",
          padding: 0,
          margin: 0,
          width: "100%",
          height: "100%",
          background: "rgba(0,0,0,0.25)",
          cursor: "pointer",
        }}
      />

      <Box
        component="dialog"
        open
        aria-labelledby="success-popup-title"
        aria-describedby="success-popup-message"
        sx={{
          position: "relative",
          width: 420,
          backgroundColor: "#FFFFFF",
          borderRadius: "16px",
          boxShadow: "0px 8px 24px rgba(0,0,0,0.12)",
          padding: 3,
          textAlign: "center",
          border: "none",
          margin: 0,
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <img
            src={SuccessIcon}
            alt="Success"
            style={{ width: "80px", height: "80px" }}
          />
        </Box>
        <Typography
          id="success-popup-title"
          sx={{ fontWeight: 600, fontSize: 22, mb: 1, color: "#1C1C1C" }}
        >
          {title}
        </Typography>
        <Typography
          id="success-popup-message"
          sx={{ fontSize: 16, color: "#4E4B44", mb: 3 }}
        >
          {message}
        </Typography>
        <Button
          variant="outlined"
          fullWidth
          sx={{
            borderRadius: "32px",
            py: 1.1,
            textTransform: "none",
            fontSize: 16,
            fontWeight: 500,
            borderColor: "#CFCEDA",
            "&:hover": { borderColor: "#CFCEDA" },
          }}
          onClick={onClose}
        >
          Close
        </Button>
      </Box>
    </Box>
  );
}

SuccessPopup.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  recipientType: PropTypes.string,
};
